export const OCR_FILE_EXTENSIONS = ['PDF', 'MARKDOWN', 'WORD', 'CSV', 'EXCEL'] as const

export type OcrFileExtension = (typeof OCR_FILE_EXTENSIONS)[number]

export const EXTENSION_MAP: Record<string, OcrFileExtension> = {
  '.pdf': 'PDF',
  '.doc': 'WORD',
  '.docx': 'WORD',
  '.md': 'MARKDOWN',
  '.txt': 'MARKDOWN',
  '.csv': 'CSV',
  '.xls': 'EXCEL',
  '.xlsx': 'EXCEL',
}

export const deriveExtension = (fileName: string): OcrFileExtension | null => {
  const lowerName = fileName.toLowerCase()
  const ext = lowerName.includes('.') ? `.${lowerName.split('.').pop()}` : ''
  return EXTENSION_MAP[ext] ?? null
}

// Review and form autofill accept standalone images; the other routes use deriveExtension.
const IMAGE_EXTENSIONS = new Set(['png', 'jpg', 'jpeg', 'webp', 'gif'])

export const deriveMultimodalExtension = (fileName: string): OcrFileExtension | 'IMAGE' | null => {
  const extension = fileName.toLowerCase().split('.').pop()
  if (fileName.includes('.') && extension && IMAGE_EXTENSIONS.has(extension)) return 'IMAGE'
  return deriveExtension(fileName)
}

// Suggested edits are drafted and applied on OOXML, so a legacy binary .doc is out of scope even
// though deriveExtension reports it as WORD for review and text extraction.
export const isDocxFileName = (fileName: string): boolean => fileName.toLowerCase().endsWith('.docx')
